import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "text-xl font-semibold" };
const _hoisted_2 = { class: "space-y-4" };
const _hoisted_3 = { class: "text-sm text-(--text-text-body)" };
const _hoisted_4 = {
    class: "space-y-2 max-h-80 overflow-y-auto",
    "data-testid": "confirm-matrix-diff-list"
};
const _hoisted_5 = { class: "text-sm" };
const _hoisted_6 = { class: "text-xs flex items-center gap-2" };
const _hoisted_7 = {
    key: 0,
    class: "bg-(--background-background-warning) border border-(--border-border-warning-subtle) rounded p-3 text-sm text-(--text-text-warning)",
    "data-testid": "deactivation-warning"
};
import { computed } from "vue";
import { Modal, Button } from "@eudonet/opal";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ConfirmMatrixChangesModal',
    props: {
        modelValue: { type: Boolean },
        diff: {},
        saving: { type: Boolean },
        purposeLabels: {}
    },
    emits: ["update:modelValue", "confirm", "cancel"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const isOpen = computed({
            get: () => props.modelValue,
            set: (value) => emit("update:modelValue", value),
        });
        const hasDeactivations = computed(() => props.diff.some((d) => !d.after));
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(Modal), {
                modelValue: isOpen.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((isOpen).value = $event)),
                size: "md",
                dismissable: true,
                "header-position": "left",
                "footer-position": "right",
                "data-testid": "confirm-matrix-modal",
                onClose: _cache[3] || (_cache[3] = ($event) => (_ctx.$emit('cancel')))
            }, {
                header: _withCtx(() => [
                    _createElementVNode("h2", _hoisted_1, _toDisplayString(_ctx.$t("consent.matrix.confirmChange.title")), 1 /* TEXT */)
                ]),
                footer: _withCtx(() => [
                    _createVNode(_unref(Button), {
                        variant: "secondary",
                        label: _ctx.$t('consent.matrix.confirmChange.cancel'),
                        disabled: __props.saving,
                        "data-testid": "confirm-matrix-cancel",
                        onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('cancel')))
                    }, null, 8 /* PROPS */, ["label", "disabled"]),
                    _createVNode(_unref(Button), {
                        variant: "primary",
                        label: _ctx.$t('consent.matrix.confirmChange.confirm'),
                        disabled: __props.saving,
                        loading: __props.saving,
                        "data-testid": "confirm-matrix-confirm",
                        onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.$emit('confirm')))
                    }, null, 8 /* PROPS */, ["label", "disabled", "loading"])
                ]),
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t("consent.matrix.confirmChange.summary", { count: __props.diff.length })), 1 /* TEXT */),
                        _createElementVNode("ul", _hoisted_4, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.diff, (d) => {
                                return (_openBlock(), _createElementBlock("li", {
                                    key: `${d.channelType}-${d.purpose}`,
                                    class: "flex items-center justify-between border-b border-(--border-border-base-soft) pb-2"
                                }, [
                                    _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t(`consent.matrix.channel.${d.channelType.toLowerCase()}`)) + " · " + _toDisplayString(__props.purposeLabels[d.purpose.toLowerCase()] ?? _ctx.$t(`consent.matrix.purpose.${d.purpose.toLowerCase()}`)), 1 /* TEXT */),
                                    _createElementVNode("span", _hoisted_6, [
                                        _createElementVNode("span", {
                                            class: _normalizeClass(d.before ? 'text-(--text-text-success)' : 'text-(--text-text-disabled-light)')
                                        }, _toDisplayString(d.before ? _ctx.$t("consent.matrix.enabled") : _ctx.$t("consent.matrix.disabled")), 3 /* TEXT, CLASS */),
                                        _cache[4] || (_cache[4] = _createElementVNode("span", null, "→", -1 /* CACHED */)),
                                        _createElementVNode("span", {
                                            class: _normalizeClass(d.after ? 'text-(--text-text-success)' : 'text-(--text-text-disabled-light)')
                                        }, _toDisplayString(d.after ? _ctx.$t("consent.matrix.enabled") : _ctx.$t("consent.matrix.disabled")), 3 /* TEXT, CLASS */)
                                    ])
                                ]));
                            }), 128 /* KEYED_FRAGMENT */))
                        ]),
                        (hasDeactivations.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.$t("consent.matrix.confirmChange.warningDeactivation")), 1 /* TEXT */))
                            : _createCommentVNode("v-if", true)
                    ])
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["modelValue"]));
        };
    }
});
